<template>
  <AppMenu />
  <router-view />
</template>

<style>
html, body {
  margin: 0;
  padding: 0;
  /* width: 100%;
  height: 100%;
  overflow: hidden; */
  background-color: #ddd;
}
</style>

<script>
import AppMenu from "./components/AppMenu";
export default {
  components: {
    AppMenu
  }
};
</script>
